import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/game";

export const gameList = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const gameAdd = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const gameEdit = async (values) => {
  return await axiosInstance(options).post(`${path}/update`, values);
};

export const gameDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const gameStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/change-status`, values);
};

export const gameDelete = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete/${id}`);
};
